<template>
  <div class="aes-container">
    <el-card class="box-card">
      <div slot="header" class="clearfix">
        <span style="font-weight: bold; font-size: 18px;">AES 加解密工具</span>
        <el-tag size="medium" style="margin-left: 10px;">支持 AES-128</el-tag>
        <el-tag size="medium" type="warning" style="margin-left: 10px;">ECB</el-tag>
      </div>

      <!-- 密钥配置区域 -->
      <el-row :gutter="20">
        <el-col :span="24">
          <div class="section-title">
            <i class="el-icon-key"></i>
            密钥配置
          </div>
        </el-col>
      </el-row>

      <el-row :gutter="20">
        <el-col :span="12">
          <el-form label-width="100px">
            <el-form-item label="密钥长度">
              <el-select v-model="keySize" placeholder="请选择密钥长度" @change="generateRandomKey" disabled>
                <el-option label="AES-128 (16字节)" :value="128"></el-option>
                <el-option label="AES-192 (24字节)" :value="192"></el-option>
                <el-option label="AES-256 (32字节)" :value="256"></el-option>
              </el-select>
            </el-form-item>

            <el-form-item label="加密模式">
             ECB模式
            </el-form-item>

            <!-- <el-form-item label="密钥(Base64)">
              <el-input
                type="textarea"
                :rows="3"
                v-model="keyBase64"
                placeholder="请输入 Base64 格式的密钥"
                @input="onKeyChange">
              </el-input>
              <el-button size="small" type="primary" @click="generateRandomKey" style="margin-top: 8px;">
                <i class="el-icon-refresh-right"></i> 生成随机密钥
              </el-button>
            </el-form-item> -->

            <el-form-item label="密钥(String)" v-if="keyHex">
              <el-input
                type="textarea"
                :rows="2"
                v-model="keyHex"
                readonly
                maxlength="16"
                placeholder="密钥十六字节字符串">
              </el-input>
            </el-form-item>
          </el-form>
        </el-col>

        <el-col :span="12">
          <el-form label-width="100px">
            <el-form-item label="填充方式">
              <el-select v-model="padding" placeholder="填充方式" disabled>
                <el-option label="PKCS7 (PKCS5Padding)" value="pkcs7"></el-option>
              </el-select>
              <span style="font-size: 12px; color: #999; margin-left: 8px;">固定为 PKCS7</span>
            </el-form-item>

            <!-- <el-form-item label="IV向量" v-if="mode === 'CBC'">
              <el-input
                type="textarea"
                :rows="3"
                v-model="ivBase64"
                placeholder="CBC模式需要16字节的IV向量(Base64格式)">
              </el-input>
              <el-button size="small" type="primary" @click="generateRandomIV" style="margin-top: 8px;">
                <i class="el-icon-refresh-right"></i> 生成随机IV
              </el-button>
            </el-form-item> -->

            <el-form-item label="输出编码">
            Base64
            </el-form-item>
          </el-form>
        </el-col>
      </el-row>

      <!-- 加密区域 -->
      <el-row :gutter="20" style="margin-top: 20px;">
        <el-col :span="24">
          <div class="section-title">
            <i class="el-icon-lock"></i>
            加密
          </div>
        </el-col>
      </el-row>

      <el-row :gutter="20">
        <el-col :span="24">
          <el-form label-width="100px">
            <el-form-item label="明文">
              <el-input
                type="textarea"
                :rows="5"
                v-model="plaintext"
                placeholder="请输入需要加密的明文">
              </el-input>
            </el-form-item>

            <el-form-item label="密文">
              <el-input
                type="textarea"
                :rows="5"
                v-model="ciphertext"
                readonly
                placeholder="加密后的结果会显示在这里">
              </el-input>
              <el-button-group style="margin-top: 8px;">
                <el-button size="small" type="success" @click="handleEncrypt" :disabled="!plaintext">
                  <i class="el-icon-lock"></i> 加密
                </el-button>
                <el-button size="small" @click="copyToClipboard(ciphertext)" :disabled="!ciphertext">
                  <i class="el-icon-document-copy"></i> 复制密文
                </el-button>
              </el-button-group>
            </el-form-item>
          </el-form>
        </el-col>
      </el-row>

      <!-- 解密区域 -->
      <el-row :gutter="20" style="margin-top: 20px;">
        <el-col :span="24">
          <div class="section-title">
            <i class="el-icon-unlock"></i>
            解密
          </div>
        </el-col>
      </el-row>

      <el-row :gutter="20">
        <el-col :span="24">
          <el-form label-width="100px">
            <el-form-item label="密文">
              <el-input
                type="textarea"
                :rows="5"
                v-model="decryptInput"
                placeholder="请输入需要解密的密文">
              </el-input>
            </el-form-item>

            <el-form-item label="解密结果">
              <el-input
                type="textarea"
                :rows="5"
                v-model="decryptedText"
                readonly
                placeholder="解密结果会显示在这里">
              </el-input>
              <el-button-group style="margin-top: 8px;">
                <el-button size="small" type="success" @click="handleDecrypt" :disabled="!decryptInput">
                  <i class="el-icon-unlock"></i> 解密
                </el-button>
                <el-button size="small" @click="copyToClipboard(decryptedText)" :disabled="!decryptedText">
                  <i class="el-icon-document-copy"></i> 复制结果
                </el-button>
              </el-button-group>
            </el-form-item>
          </el-form>
        </el-col>
      </el-row>

      <!-- 快捷操作 -->
      <el-row :gutter="20" style="margin-top: 20px;">
        <el-col :span="24">
          <el-divider></el-divider>
          <div style="text-align: center;">
            <el-button type="danger" plain @click="clearAll">
              <i class="el-icon-delete"></i> 清空所有
            </el-button>
            <el-button type="info" plain @click="fillTestData">
              <i class="el-icon-edit-outline"></i> 填充测试数据
            </el-button>
            <el-button type="primary" plain @click="testCompatibility">
              <i class="el-icon-check"></i> 测试兼容性
            </el-button>
          </div>
        </el-col>
      </el-row>
    </el-card>
  </div>
</template>

<script>
import CryptoJS from 'crypto-js'
import { AESKEY, aesEncryp, aesDecrypt } from 'comm/src/utils/cryptoJs'
export default {
  name: 'AESEncryptTool',
  data() {
    return {
      keySize: 128,              // 密钥长度 128/192/256
      mode: 'ECB',               // ECB / CBC
      padding: 'pkcs7',          // 填充方式
      outputEncoding: 'base64',  // 输出编码 base64/hex
      keyBase64: AESKEY,             // Base64格式密钥
      keyHex: AESKEY,                // Hex格式密钥
      ivBase64: '',              // IV向量 (Base64)
      plaintext: '',             // 明文
      ciphertext: '',            // 密文
      decryptInput: '',          // 待解密的密文
      decryptedText: ''          // 解密结果
    }
  },
  watch: {
    // 监听密钥变化，更新Hex显示
    keyBase64(val) {
      if (val) {
        try {
          const keyWordArray = CryptoJS.enc.Base64.parse(val)
          this.keyHex = keyWordArray.toString(CryptoJS.enc.Hex)
        } catch (e) {
          this.keyHex = ''
        }
      } else {
        this.keyHex = ''
      }
    },
    // 监听模式变化，如果是ECB模式则清空IV
    mode(val) {
      if (val === 'ECB') {
        this.ivBase64 = ''
      }
    }
  },
  mounted() {
    // 初始化时生成随机密钥和IV
    // this.generateRandomKey()
    // this.generateRandomIV()
  },
  methods: {
    /**
     * 生成随机密钥
     */
    generateRandomKey() {
      const keyBytes = this.keySize / 8
      const randomBytes = CryptoJS.lib.WordArray.random(keyBytes)
      this.keyBase64 = randomBytes.toString(CryptoJS.enc.Base64)
      this.$message.success(`已生成 ${this.keySize} 位随机密钥`)
    },

    /**
     * 生成随机IV (16字节)
     */
    generateRandomIV() {
      const ivBytes = CryptoJS.lib.WordArray.random(16)
      this.ivBase64 = ivBytes.toString(CryptoJS.enc.Base64)
      if (this.mode === 'CBC') {
        this.$message.success('已生成随机IV')
      }
    },

    /**
     * 密钥变化时的处理
     */
    onKeyChange() {
      if (this.keyBase64) {
        try {
          const keyBytes = CryptoJS.enc.Base64.parse(this.keyBase64)
          const actualBytes = keyBytes.sigBytes
          const expectedBytes = this.keySize / 8
          
          if (actualBytes !== expectedBytes) {
            this.$message.warning(`密钥长度 ${actualBytes} 字节，当前选择的是 ${expectedBytes} 字节密钥`)
          }
        } catch (e) {
          this.$message.error('密钥格式错误，请确保是有效的Base64字符串')
        }
      }
    },

    /**
     * 执行加密
     */
    async handleEncrypt() {
      if (!this.plaintext) {
        this.$message.warning('请输入需要加密的明文')
        return
      }

      if (!this.keyBase64) {
        this.$message.warning('请先设置密钥')
        return
      }

      try {
        // 执行加密
        const encrypted = aesEncryp(this.plaintext)
        
        // 格式化输出
        if (this.outputEncoding === 'base64') {
          this.ciphertext = encrypted.toString()
        } else {
          this.ciphertext = encrypted.ciphertext.toString(CryptoJS.enc.Hex)
        }
        
        this.$message.success('加密成功')
      } catch (error) {
        console.error('加密失败:', error)
        this.$message.error(`加密失败: ${error.message}`)
      }
    },

    /**
     * 执行解密
     */
    async handleDecrypt() {
      if (!this.decryptInput) {
        this.$message.warning('请输入需要解密的密文')
        return
      }

      if (!this.keyBase64) {
        this.$message.warning('请先设置密钥')
        return
      }

      try {
        
        // 执行解密
        const decrypted = aesDecrypt(this.decryptInput)
        const result = decrypted.toString(CryptoJS.enc.Utf8)
        
        if (!result) {
          throw new Error('解密失败，可能是密钥错误或密文格式不正确')
        }
        
        this.decryptedText = result
        this.$message.success('解密成功')
      } catch (error) {
        console.error('解密失败:', error)
        this.$message.error(`解密失败: ${error.message}`)
      }
    },

    /**
     * 清空所有数据
     */
    clearAll() {
      this.plaintext = ''
      this.ciphertext = ''
      this.decryptInput = ''
      this.decryptedText = ''
      this.$message.info('已清空所有数据')
    },

    /**
     * 填充测试数据
     */
    fillTestData() {
      this.plaintext = 'Hello AES! 这是测试数据 1234567890 中文测试。'
      this.decryptInput = this.ciphertext || ''
      this.$message.info('已填充测试数据')
    },

    /**
     * 测试兼容性（自测加解密）
     */
    testCompatibility() {
      if (!this.plaintext) {
        this.$message.warning('请先输入明文或点击"填充测试数据"')
        return
      }
      
      // 先加密
      this.handleEncrypt().then(() => {
        // 加密成功后自动解密
        if (this.ciphertext) {
          this.decryptInput = this.ciphertext
          this.handleDecrypt()
          
          // 验证
          setTimeout(() => {
            if (this.decryptedText === this.plaintext) {
              this.$message.success('✅ 加解密兼容性测试通过！')
            } else {
              this.$message.error('❌ 加解密兼容性测试失败，请检查配置')
            }
          }, 500)
        }
      }).catch(() => {
        this.$message.error('加密失败，无法进行兼容性测试')
      })
    },

    /**
     * 复制到剪贴板
     */
    copyToClipboard(text) {
      if (!text) {
        this.$message.warning('没有可复制的内容')
        return
      }
      
      // 创建临时文本域
      const textarea = document.createElement('textarea')
      textarea.value = text
      document.body.appendChild(textarea)
      textarea.select()
      
      try {
        document.execCommand('copy')
        this.$message.success('已复制到剪贴板')
      } catch (err) {
        this.$message.error('复制失败，请手动复制')
      } finally {
        document.body.removeChild(textarea)
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.aes-container {
  padding: 20px;
  background-color: #f0f2f5;
  height: 100vh;
}

.box-card {
  margin: 0 auto;
}

::v-deep .el-card__body {
    padding: 20px;
    box-sizing: border-box;
    overflow-y: auto;
    height: 90vh;
}

.section-title {
  font-size: 16px;
  font-weight: bold;
  margin: 20px 0 15px 0;
  padding-bottom: 10px;
  border-bottom: 2px solid #e4e7ed;
  color: #303133;
}

.section-title i {
  margin-right: 8px;
  color: #409eff;
}

.clearfix:before,
.clearfix:after {
  display: table;
  content: "";
}

.clearfix:after {
  clear: both;
}

::v-deep .el-textarea__inner {
  font-family: 'Courier New', monospace;
  font-size: 13px;
}

::v-deep .el-form-item {
  margin-bottom: 18px;
}
</style>